import { FC, ReactNode } from 'react';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import clsx from 'clsx';

import classes from './Column.module.scss';

export interface ColumnProps {
  title: ReactNode;
  content: ReactNode;
  className?: string;
  testId?: string;
}

export const Column: FC<ColumnProps> = ({
  title,
  content,
  className,
  testId,
}) => {
  return (
    <div className={clsx(classes.column, className)} data-testid={testId}>
      <div className={classes.title}>
        <Typography variant='caption' ellipsis data-testid={`${testId}Title`}>
          {title}
        </Typography>
      </div>
      <div data-testid={`${testId}Content`}>{content}</div>
    </div>
  );
};
